import axios from "axios";
import store from "@/store";
import { getToken } from "@/utils/auth";
import { Message, MessageBox } from "element-ui";

let logoutConfirming = false;

function forceLogout(msg) {
  if (logoutConfirming) return;
  logoutConfirming = true;
  MessageBox.alert(msg || "登录已失效，请重新登录", "提示", {
    confirmButtonText: "确定",
    type: "warning",
    closeOnClickModal: false,
    closeOnPressEscape: false
  })
    .then(() => {
      const accessToken = sessionStorage.getItem("Authorization") || "";
      return store.dispatch("user/resetToken").finally(() => {
        window.location.href =
          process.env.VUE_APP_KW_AUTH_BASE_URL +
          "enterpriseAuth/logout?accessToken=" +
          accessToken +
          "&systemType=kwjfComClient";
      });
    })
    .finally(() => {
      logoutConfirming = false;
    });
}

const service = axios.create({
  baseURL: process.env.VUE_APP_KW_AUTH_BASE_URL,
  // baseURL: "",
  timeout: 50000
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
        config.headers["userId"] = getToken();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (Number(res.code) === 200) {
      return res;
    }
    if (Number(res.code) === 410) {
      forceLogout(res.msg);
      return Promise.reject(res);
    }
    Message.error(res.msg || "请求失败");
    return Promise.reject(res);
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
